"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClassifyTabContainer;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
var _reportUtil = require("../../utils/reportUtil");
var _intlDesignUi = require("@tencent/intl-design-ui");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ClassifyTabContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos,
  componentKey
}) {
  const _data$modTitle = data.modTitle,
    modTitle = _data$modTitle === void 0 ? '' : _data$modTitle,
    _data$desc = data.desc,
    desc = _data$desc === void 0 ? '' : _data$desc,
    cid = data.cid,
    color = data.color,
    gradientColor = data.gradientColor,
    _data$list = data.list,
    list = _data$list === void 0 ? [] : _data$list;
  const bgStyle = {};
  if (color) {
    bgStyle.background = color;
  }
  const paddingStyle = {
    minWidth: 'unset'
  };
  if (gradientColor) {
    bgStyle.background = '';
    bgStyle.backgroundImage = gradientColor;
  }
  const resultList = list.map((item, index) => {
    const _item$name = item.name,
      name = _item$name === void 0 ? '' : _item$name;
    return {
      name,
      id: name,
      extendProps: {
        'report-event': 'click_classifyTab_tab',
        'report-ext1': index,
        'report-ext2': name || ''
      }
    };
  });
  const _useState = (0, _react.useState)(list.length > 0 ? list[0].name : ''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    classifyName = _useState2[0],
    setClassifyName = _useState2[1]; // 分页组件默认显示的组件的页
  const renderChild = child => {
    return child ? /*#__PURE__*/_react.default.cloneElement(child, {
      domains: domainInfos,
      filterOptions: {
        classifyName,
        layoutMode: true
      }
    }) : child;
  };
  // 点击分类的回调函数
  const onTabChange = classifyName => {
    setClassifyName(classifyName);
  };
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({
    id: cid
  }, (0, _reportUtil.reportShow)(['show_ClassifyTabContainer', componentKey, cid]), {
    style: bgStyle
  }), /*#__PURE__*/_react.default.createElement(_intlDesignUi.Section, {
    col: 1,
    style: paddingStyle,
    title: modTitle,
    desc: desc
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "classify-tab-container"
  }, /*#__PURE__*/_react.default.createElement(_intlDesignUi.ClassifyTab, {
    list: resultList,
    onChange: currentClick => {
      onTabChange(currentClick);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "classify-tab-container-child"
  }, _react.default.Children.map(children, (child, index) => /*#__PURE__*/_react.default.createElement("div", {
    style: commonStyle,
    key: index
  }, renderChild(child)))))));
}